import client from '@/tina/__generated__/client';
import { PageQuery } from '@/tina/__generated__/types';
export type Crumb = {
  name: string;
  url: string;
  isCurrentPage?: boolean;
};
type resolveBreadcrumbsParams<T> = {
  page: PageQuery['page'];
  childBreadcrumbs?: Crumb[];
};
export async function resolveBreadcrumbs<T extends PageQuery>({
  page,
  childBreadcrumbs = []
}: resolveBreadcrumbsParams<T>) {
  const pageUrl = page._sys.breadcrumbs.join('/');
  const breadcrumbs = [{
    name: page.pageName,
    url: pageUrl,
    isCurrentPage: childBreadcrumbs.length === 0
  }, ...childBreadcrumbs];
  const parentPageUrl = page?.pageSettings?.parent?._sys.breadcrumbs.join('/');
  if (parentPageUrl) {
    //ensure that the page's parent is not the page itself
    const breadcrumbsDoNotIncludeParentUrl = breadcrumbs.reduce((acc, {
      url
    }) => acc ? url !== parentPageUrl : acc, true);
    if (breadcrumbsDoNotIncludeParentUrl) {
      //fetch the parent page
      const {
        data: {
          page: parentPage
        }
      } = await client.queries.page({
        relativePath: parentPageUrl + '.mdx'
      });
      return resolveBreadcrumbs({
        page: parentPage,
        childBreadcrumbs: breadcrumbs
      });
    }
    return resolveWithHomepage(breadcrumbs);
  }
  return resolveWithHomepage(breadcrumbs);
}
function resolveWithHomepage(breadcrumbs: Crumb[] = []): Crumb[] {
  return [{
    name: 'Home',
    url: '/'
  }, ...breadcrumbs];
}